import { apiConfig } from '../../infrastructure/config/api.config';
import { LocalStorageTokenStorage } from '../../infrastructure/storage/local-storage-token-storage';
import { FetchHttpClient } from '../../infrastructure/http/fetch-http-client';
import { HttpSocialNetworkRepository } from '../../infrastructure/repositories/http-social-network.repository';
import { GetSocialNetworksUseCase } from '../../application/use-cases/social-networks/get-social-networks.use-case';
import { GetSocialNetworkByIdUseCase } from '../../application/use-cases/social-networks/get-social-network-by-id.use-case';
import { CreateSocialNetworkUseCase } from '../../application/use-cases/social-networks/create-social-network.use-case';
import { UpdateSocialNetworkUseCase } from '../../application/use-cases/social-networks/update-social-network.use-case';
import { ChangeSocialNetworkStatusUseCase } from '../../application/use-cases/social-networks/change-social-network-status.use-case';
import { ReorderSocialNetworksUseCase } from '../../application/use-cases/social-networks/reorder-social-networks.use-case';
import { DeleteSocialNetworkUseCase } from '../../application/use-cases/social-networks/delete-social-network.use-case';

export interface SocialNetworkUseCases {
  getSocialNetworksUseCase: GetSocialNetworksUseCase;
  getSocialNetworkByIdUseCase: GetSocialNetworkByIdUseCase;
  createSocialNetworkUseCase: CreateSocialNetworkUseCase;
  updateSocialNetworkUseCase: UpdateSocialNetworkUseCase;
  changeSocialNetworkStatusUseCase: ChangeSocialNetworkStatusUseCase;
  reorderSocialNetworksUseCase: ReorderSocialNetworksUseCase;
  deleteSocialNetworkUseCase: DeleteSocialNetworkUseCase;
}

export const makeSocialNetworkUseCases = (): SocialNetworkUseCases => {
  const tokenStorage = new LocalStorageTokenStorage();
  const httpClient = new FetchHttpClient(apiConfig.baseUrl, () => tokenStorage.getToken());
  const repository = new HttpSocialNetworkRepository(httpClient);

  return {
    getSocialNetworksUseCase: new GetSocialNetworksUseCase(repository),
    getSocialNetworkByIdUseCase: new GetSocialNetworkByIdUseCase(repository),
    createSocialNetworkUseCase: new CreateSocialNetworkUseCase(repository),
    updateSocialNetworkUseCase: new UpdateSocialNetworkUseCase(repository),
    changeSocialNetworkStatusUseCase: new ChangeSocialNetworkStatusUseCase(repository),
    reorderSocialNetworksUseCase: new ReorderSocialNetworksUseCase(repository),
    deleteSocialNetworkUseCase: new DeleteSocialNetworkUseCase(repository),
  };
};
